import React from 'react';
import { Formik, ErrorMessage } from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import * as Types from 'helpers/types';
import { useDispatch } from 'react-redux';
import { editAddress, deleteAddress } from 'services/api';
import styles from './style.module.css';
import PropTypes from 'prop-types';
import { validatePostcode } from 'helpers/yupmatchers';

const EditAddressSchema = Yup.object().shape({
  address_line1: Yup.string().max(255, 'Cannot be over 255 characters').required('Address is empty'),
  city_town: Yup.string().max(255, 'Cannot be over 255 characters').required('City/Town is empty'),
  postcode: validatePostcode,
});

const EditAddressForm = ({ initialValues, redirect, addressId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const submitForm = async (payload, actions) => {
    const refined_payload = {
      name: payload.name,
      address_line1: payload.address_line1,
      address_line2: payload.address_line2,
      address_line3: payload.city_town,
      address_line4: payload.county,
      address_line5: '',
      postcode: payload.postcode,
      id: addressId,
    };

    try {
      await editAddress(refined_payload, addressId);
      actions.setSubmitting(false);
      dispatch({ type: Types.EDIT_ADDRESS_CLEAR });
      history.push(redirect);
    } catch (e) {
      actions.setSubmitting(false);
      history.push('/pharmacy/error');
    }
  };

  const submitDelete = async () => {
    //To change
    try {
      await deleteAddress(addressId);
      dispatch({ type: Types.EDIT_ADDRESS_CLEAR });
      history.push(redirect);
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={EditAddressSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, actions) => submitForm(values, actions)}>
      {(props) => (
        <form className={styles.form} onSubmit={props.handleSubmit}>
          <div className={styles.formInputContainer}>
            <label htmlFor="name">
              Nickname
              <input
                maxLength="255"
                id="name"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.name}
                name="name"
              />
            </label>
            <label htmlFor="address_line1">
              Address Line 1
              <ErrorMessage
                name="address_line1"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="255"
                id="address_line1"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.address_line1}
                name="address_line1"
                className={`coop-form__input ${
                  props.errors.address_line1 && props.touched.address_line1 && 'coop-form__invalid'
                }`}
              />
            </label>
            <label htmlFor="address_line2">
              Address Line 2 (optional)
              <input
                maxLength="255"
                id="address_line2"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.address_line2}
                name="address_line2"
              />
            </label>
            <label htmlFor="city_town">
              Town or City
              <ErrorMessage
                name="city_town"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="255"
                id="city_town"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.city_town}
                name="city_town"
                className={`coop-form__input ${
                  props.errors.city_town && props.touched.city_town && 'coop-form__invalid'
                }`}
              />
            </label>
            <label htmlFor="county">
              County
              <input
                maxLength="255"
                id="county"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.county}
                name="county"
              />
            </label>
            <label className={styles.mb0} htmlFor="postcode">
              Postcode
              <ErrorMessage
                name="postcode"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="255"
                id="postcode"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.postcode}
                className={`coop-form__input ${
                  props.errors.postcode && props.touched.postcode && 'coop-form__invalid'
                }`}
                name="postcode"
              />
            </label>
          </div>
          <button type="submit" className={`coop-btn coop-btn--primary coop-c-hero__cta ${styles.submit}`}>
            Update address
          </button>
          <button type="button" className={`coop-btn coop-c-hero__cta ${styles.submit}`} onClick={() => submitDelete()}>
            Delete address
          </button>
        </form>
      )}
    </Formik>
  );
};

EditAddressForm.propTypes = {
  initialValues: PropTypes.shape({
    nickname: '',
    address_line1: '',
    address_line2: '',
    city_town: '',
    county: '',
    postcode: '',
  }).isRequired,
  redirect: PropTypes.string.isRequired,
  addressId: PropTypes.number.isRequired,
};

EditAddressForm.defaultProps = {
  initialValues: {
    nickname: '',
    address_line1: '',
    address_line2: '',
    city_town: '',
    county: '',
    postcode: '',
  },
  redirect: '/pharmacy/dashboard/account/address',
  addressId: 0,
};

export default EditAddressForm;
